const ConditionalWrapper = ({ condition, wrapperFn, ...props}) => {
  return (
    condition ? wrapperFn(props.children) : props.children
  )
}

export default ConditionalWrapper